module.exports = __webpack_public_path__ + "img/coin.b91393c1.png";